import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const DEVICES_PATH = '/api/devices';

// Admin fleet console API (all require devices:manage). The agent-facing
// register/heartbeat/ack endpoints are not exposed here — those are called by
// the on-device native agent, not the web console.
const getDevices = async (params = {}) => {
  const response = await axios.get(`${API_BASE_URL}${DEVICES_PATH}`, { params });
  return response.data.data;
};

const getDevice = async (deviceId) => {
  const response = await axios.get(`${API_BASE_URL}${DEVICES_PATH}/${encodeURIComponent(deviceId)}`);
  return response.data.data;
};

const updateDevice = async (deviceId, updates) => {
  const response = await axios.patch(
    `${API_BASE_URL}${DEVICES_PATH}/${encodeURIComponent(deviceId)}`,
    updates
  );
  return response.data.data;
};

const getCommands = async (deviceId, params = {}) => {
  const response = await axios.get(
    `${API_BASE_URL}${DEVICES_PATH}/${encodeURIComponent(deviceId)}/commands`,
    { params }
  );
  return response.data.data;
};

const issueCommand = async (deviceId, type, payload = null) => {
  const response = await axios.post(
    `${API_BASE_URL}${DEVICES_PATH}/${encodeURIComponent(deviceId)}/commands`,
    { type, payload }
  );
  return response.data.data;
};

const deviceService = {
  getDevices,
  getDevice,
  updateDevice,
  getCommands,
  issueCommand,
};

export default deviceService;
